var directive = function($anchorScroll) {
  return {
    link: 'A',
    scope: false,
    link: function(scope,element,attrs) {
      var callback = function() {
        var successEventUnbind, failEventUnbind,
          unbind = function() {
            successEventUnbind();
            failEventUnbind();
            element.off('click', callback);
          }

        successEventUnbind =
          scope.$root.$on('$stateChangeSuccess', function() {
            $anchorScroll();
            unbind();
          });

        failEventUnbind =
          scope.$root.$on('$stateChangeError', function() {
            unbind();
          });
      };

      element.on('click', callback);

      scope.$on('$destroy', function() {
        element.off('click', callback);
      });
    }
  };
};

directive.$inject = ['$anchorScroll'];

tiz.directive('scrollToTopOnStateChange', directive);
